import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import { H2 } from 'ha/ui/Headers';
import MediaQuery from 'ha/helpers/MediaQuery';
import Track from 'ha/components/track/SmartTrack';
import Link from 'ha/ui/Link';

interface Props {
  isAuthenticated: boolean;
  showModal: (name: string, nextUrl: string) => void;
}

const CTABlock: React.SFC<Props & IntlProps> = ({
  intl: { T, urlResolver },
  isAuthenticated,
  showModal,
}) => (
  <MediaQuery>
    {({ md }) => (
      <div
        className={cx(
          'back-dark color-white text-center p-x-1_5',
          md ? 'p-y-5' : 'p-y-3_5',
        )}
      >
        <H2 className={cx('m-b-0_8', { 'font-size-xl': md })}>
          {T('Start listing your property now')}
        </H2>
        <div
          className={cx('color-grey-9', md ? 'm-b-3_5 font-size-lg' : 'm-b-3')}
        >
          {T("We're pretty sure you'll love it")}
        </div>
        <Track name="Clicked CTA List your place" type="link">
          <Link
            to={urlResolver.getListYourPlaceUrl()}
            className={cx(
              'btn btn-brand text-bold btn-xl btn-wrap box-shadow-md p-x-1 supply-landing-cta-block--btn',
              md ? 'm-b-1_5' : 'm-b-2_5',
            )}
            skipLangFormat
            onClick={
              isAuthenticated
                ? undefined
                : e => {
                    e.preventDefault();
                    showModal('register', urlResolver.getListYourPlaceUrl());
                  }
            }
          >
            {T('Yes, I want to earn money and save more time')}
          </Link>
        </Track>
        <div className="color-grey-9">
          {T('Try out our first booking for free!')}
        </div>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(CTABlock);
